// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3_wGB","log":"ModalInventoryLogs_log__1naT6","date":"ModalInventoryLogs_date__3i4xv","userName":"ModalInventoryLogs_userName__1_bw9"};